import { CHAIN_ID, TokenInfo as Token } from '@derivation-tech/context';
import { MarketType } from '@synfutures/sdks-perp';
import { BigNumber, constants } from 'ethers';

import { DAPP_CHAIN_CONFIGS } from '@/constants/chain';
import { DEFAULT_DECIMALS } from '@/constants/global';
import { TokenInfo } from '@/types/token';

export function getTokenInfo(token: Token, chainId: CHAIN_ID): TokenInfo {
  return {
    ...token,
    id: token.address.toLowerCase(),
    address: token.address.toLowerCase(),
    chainId,
    decimals: token.decimals || DEFAULT_DECIMALS,
  };
}

export function isWrappedNativeToken(chainId: CHAIN_ID, address: string, wrappedNativeToken?: Token): boolean {
  if (!wrappedNativeToken) {
    const dappChainConfig = DAPP_CHAIN_CONFIGS[chainId];
    wrappedNativeToken = dappChainConfig?.wrappedNativeToken;
  }

  return address?.toLowerCase() === wrappedNativeToken?.address?.toLowerCase();
}

export function isNativeTokenAddr(tokenAddr: string): boolean {
  if (!tokenAddr) return false;
  return tokenAddr.toLowerCase() === constants.AddressZero;
}

export function isNativeTokenInfo(token: TokenInfo): boolean {
  return isNativeTokenAddr(token?.address) && !token.id.startsWith(`${MarketType.LINK}_`);
}

export function fixBalanceNumberDecimalsTo18(num: BigNumber, tokenDecimals: number): BigNumber {
  return num.mul(10 ** (18 - tokenDecimals));
}

/**
 * Convert token amount (as bigint) to 18 decimals
 * @param num Amount to convert
 * @param tokenDecimals Original token decimals
 * @returns Converted amount with 18 decimals
 */
export function fixTokenBigIntDecimalsTo18(num: bigint, tokenDecimals: number): bigint {
  return num * BigInt(10 ** (18 - tokenDecimals));
}

export function adjustBalanceNumberToTokenDecimals(num: BigNumber, tokenDecimals: number): BigNumber {
  return num.div(10 ** (18 - tokenDecimals));
}

export function mappingToken({
  token,
  chainId,
  marketType,
  unWrappedNativeToken = false,
}: {
  token: Token;
  marketType?: MarketType;
  chainId: CHAIN_ID;
  unWrappedNativeToken?: boolean;
}): TokenInfo {
  const dappChainConfig = DAPP_CHAIN_CONFIGS[chainId];
  if (dappChainConfig) {
    if (unWrappedNativeToken && isWrappedNativeToken(chainId, token.address)) {
      if (dappChainConfig.nativeToken) token = dappChainConfig.nativeToken;
    }
  }

  const mToken: TokenInfo = getTokenInfo(token, chainId);

  // transform chainlink token's id
  if (marketType && [MarketType.LINK, MarketType.EMG, MarketType.PYTH].includes(marketType)) {
    // if (marketType && [MarketType.CHAINLINK, MarketType.SYNFUTURES].includes(marketType)) {
    mToken.id = `${marketType}_${mToken.symbol}`;
  }
  return mToken;
}
